import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./MedicalEquipments.css";
import "../Diagnostic/PackageDetail.css"; // Nursing Booking style layout stylesheet
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import EastOutlinedIcon from "@mui/icons-material/EastOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WhyTrust from "../layout/WhyTrust";
import { fetchAPI, fetchUserAppAPI } from "../utils/api";
import AddAddressModal from "../components/AddAddressModal";

export default function MedicineCheckout() {
  const navigate = useNavigate();
  const location = useLocation();

  const [cartItems, setCartItems] = useState([]);
  const [summary, setSummary] = useState({
    product_total: 0,
    security_total: 0,
    gst_total: 0,
    grand_total: 0,
  });

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("Jaipur");
  const [state, setState] = useState("Rajasthan");
  const [pincode, setPincode] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("Cash on Delivery");
  const [orderNotes, setOrderNotes] = useState("");
  const [loading, setLoading] = useState(false);

  const [addresses, setAddresses] = useState([]);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [showAddressModal, setShowAddressModal] = useState(false);

  const handleAddAddressSuccess = (newAddress) => {
    const userStr = localStorage.getItem("user");
    if (userStr) {
      try {
        const parsed = JSON.parse(userStr);
        fetchUserAddresses(parsed.user_id);
      } catch (e) {}
    }
    if (newAddress) {
      setSelectedAddressId(newAddress.address_id);
      populateAddressFields(newAddress);
    }
  };

  const fetchUserAddresses = async (userId) => {
    try {
      const response = await fetchUserAppAPI("list-address", {
        method: "POST",
        body: JSON.stringify({ user_id: userId }),
      });
      if (
        response &&
        response.status === 200 &&
        Array.isArray(response.result)
      ) {
        setAddresses(response.result);

        // Match the header selected address or fallback to default
        const savedSel = localStorage.getItem("selectedAddress");
        let activeAddr = null;
        if (savedSel) {
          try {
            const parsedSel = JSON.parse(savedSel);
            activeAddr = response.result.find(
              (a) => a.address_id === parsedSel.address_id,
            );
          } catch (e) {}
        }
        if (!activeAddr && response.result.length > 0) {
          activeAddr =
            response.result.find((a) => a.address_default == 1) ||
            response.result[0];
        }

        if (activeAddr) {
          setSelectedAddressId(activeAddr.address_id);
          populateAddressFields(activeAddr);
        }
      }
    } catch (err) {
      console.error("Error fetching user addresses in checkout:", err);
    }
  };

  const populateAddressFields = (addr) => {
    if (addr.address_name) {
      const names = addr.address_name.split(" ");
      setFirstName(names[0] || "");
      setLastName(names.slice(1).join(" ") || "");
    }
    if (addr.address_phone) setPhone(addr.address_phone);

    let addrStr = "";
    if (addr.address_plot_no) addrStr += addr.address_plot_no + ", ";
    if (addr.address_locility) addrStr += addr.address_locility;
    if (addr.address_area && addr.address_area !== addr.address_pincode) {
      addrStr += ", " + addr.address_area;
    }
    setAddress(addrStr || addr.address_info || "");

    const cityVal =
      addr.address_city_name ||
      (addr.address_city && isNaN(addr.address_city) ? addr.address_city : "");
    const stateVal =
      addr.address_state_name ||
      (addr.address_state && isNaN(addr.address_state)
        ? addr.address_state
        : "");

    if (cityVal) setCity(cityVal);
    else if (addr.address_city === "1" || addr.address_city === 1)
      setCity("Jaipur");
    else if (addr.address_city) setCity(addr.address_city);

    if (stateVal) setState(stateVal);
    else if (addr.address_state === "1" || addr.address_state === 1)
      setState("Rajasthan");
    else if (addr.address_state) setState(addr.address_state);

    if (addr.address_pincode) setPincode(addr.address_pincode);
  };

  const handleSelectLocalAddress = (addr) => {
    setSelectedAddressId(addr.address_id);
    populateAddressFields(addr);
    localStorage.setItem("selectedAddress", JSON.stringify(addr));
    // Notify header dropdown to update in real-time
    window.dispatchEvent(new Event("addressChanged"));
  };

  useEffect(() => {
    const userStr = localStorage.getItem("user");
    let userId = null;
    if (userStr) {
      try {
        const parsed = JSON.parse(userStr);
        setFirstName(parsed.user_first_name || "");
        setLastName(parsed.user_last_name || "");
        setEmail(parsed.user_email || "");
        setPhone(parsed.user_mobile || "");
        userId = parsed.user_id;
        fetchUserAddresses(parsed.user_id);
      } catch (e) {
        console.error("Error parsing user from localStorage:", e);
      }
    }

    const onAddressChange = () => {
      const savedSel = localStorage.getItem("selectedAddress");
      if (savedSel) {
        try {
          const parsedSel = JSON.parse(savedSel);
          setSelectedAddressId(parsedSel.address_id);
          populateAddressFields(parsedSel);
        } catch (e) {}
      }
    };

    window.addEventListener("addressChanged", onAddressChange);

    if (location.state && location.state.product) {
      const prod = location.state.product;
      const attr = location.state.selectedAttribute;
      if (prod && attr) {
        const itemPrice = parseFloat(attr.price || 0);
        const itemSecurity = parseFloat(prod.me_security_amount || 0);
        const itemGst = itemPrice * 0.05;
        const itemTotal = itemPrice + itemSecurity + itemGst;

        const item = {
          cart_product_id: prod.me_id,
          cart_attribute_value_id: attr.attribute_value_id,
          cart_qty: 1,
          cart_unit_price: itemPrice,
          cart_securiry_amount: itemSecurity,
          cart_product_gst: itemGst,
          cart_total_price: itemTotal,
          me_product_name: prod.me_product_name,
          me_image: prod.me_image,
          attribute: {
            attribute_value: attr.attribute_value,
          },
        };
        setCartItems([item]);
        setSummary({
          product_total: itemPrice,
          security_total: itemSecurity,
          gst_total: itemGst,
          grand_total: itemTotal,
        });
      }
    } else if (userId) {
      fetchCart(userId);
    }

    return () => {
      window.removeEventListener("addressChanged", onAddressChange);
    };
  }, [location.state]);

  const fetchCart = async (userId) => {
    try {
      const response = await fetchAPI("EquipmentsController/cart_list", {
        method: "POST",
        body: JSON.stringify({ user_id: userId }),
      });
      if (response && response.status === 200) {
        setCartItems(response.result || []);
        if (response.summary) {
          setSummary(response.summary);
        }
      }
    } catch (err) {
      console.error("Error fetching cart list:", err);
    }
  };

  const [toast, setToast] = useState({
    show: false,
    message: "",
    type: "success",
  });

  const showToast = (message, type = "success") => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast({ show: false, message: "", type: "success" });
    }, 3500);
  };

  const isDirectBuy = !!(location.state && location.state.product);

  const handlePayNow = async (e) => {
    e.preventDefault();

    const userStr = localStorage.getItem("user");
    if (!userStr) {
      showToast("Please login first to place an order.", "warning");
      window.dispatchEvent(new Event("openLoginModal"));
      return;
    }

    let user;
    try {
      user = JSON.parse(userStr);
    } catch (err) {
      showToast("Invalid session. Please login again.", "warning");
      window.dispatchEvent(new Event("openLoginModal"));
      return;
    }

    if (!firstName || !phone || !address || !city || !state || !pincode) {
      showToast("Please fill in all required shipping fields.", "warning");
      return;
    }

    if (cartItems.length === 0) {
      showToast("Your cart is empty.", "warning");
      return;
    }

    try {
      setLoading(true);

      // 1. If direct buy, first add the item to cart in DB so create_order can find it
      if (isDirectBuy && cartItems.length > 0) {
        const item = cartItems[0];
        try {
          await fetchAPI("EquipmentsController/add_to_cart", {
            method: "POST",
            body: JSON.stringify({
              user_id: user.user_id,
              product_id: item.cart_product_id,
              attribute_value_id: item.cart_attribute_value_id,
              qty: item.cart_qty || 1,
            }),
          });
        } catch (e) {
          console.warn("Direct buy add_to_cart warning:", e);
        }
      }

      // 2. Check if the inputs match the currently selected address to avoid duplicate saving
      let addressId = null;
      const savedSel = localStorage.getItem("selectedAddress");
      if (savedSel) {
        try {
          const parsedSel = JSON.parse(savedSel);
          const nameMatches =
            parsedSel.address_name ===
            (firstName + " " + (lastName || "")).trim();
          const phoneMatches = parsedSel.address_phone === phone;
          const cityMatches =
            (parsedSel.address_city_name || parsedSel.address_city) === city ||
            parsedSel.address_city === city;
          const stateMatches =
            (parsedSel.address_state_name || parsedSel.address_state) ===
              state || parsedSel.address_state === state;
          const pinMatches = parsedSel.address_pincode === pincode;

          if (
            nameMatches &&
            phoneMatches &&
            cityMatches &&
            stateMatches &&
            pinMatches
          ) {
            addressId = parsedSel.address_id;
          }
        } catch (e) {}
      }

      if (!addressId) {
        const addressResponse = await fetchUserAppAPI("add-address", {
          method: "POST",
          body: JSON.stringify({
            user_id: user.user_id,
            address_default: 1,
            address_title: "Shipping Address",
            address_name: (firstName + " " + (lastName || "")).trim(),
            address_phone: phone,
            address_plot_no: 0,
            address_locility: address,
            address_area: pincode,
            address_city: city,
            address_state: state,
            address_pincode: pincode,
            address_latitude: "",
            address_longitude: "",
          }),
        });

        if (addressResponse && addressResponse.status === 200) {
          if (addressResponse.result && addressResponse.result[0]) {
            addressId = addressResponse.result[0].address_id;
          } else {
            addressId = addressResponse.result?.address_id;
          }
        }
      }

      if (!addressId) {
        showToast(
          "Failed to save shipping address. Please try again.",
          "error",
        );
        setLoading(false);
        return;
      }

      // 3. Call create_order using user_id and address_id
      let response = null;
      try {
        response = await fetchAPI("EquipmentsController/create_order", {
          method: "POST",
          body: JSON.stringify({
            user_id: user.user_id,
            address_id: addressId,
            payment_method: paymentMethod,
            order_notes: orderNotes,
          }),
        });
      } catch (err1) {
        response = await fetchUserAppAPI("equipments-create-order", {
          method: "POST",
          body: JSON.stringify({
            user_id: user.user_id,
            address_id: addressId,
            payment_method: paymentMethod,
            order_notes: orderNotes,
          }),
        });
      }

      if (response && (response.status === 200 || response.status === "200")) {
        // Clear all local cart data after successful order
        localStorage.removeItem("selectedProductCart");
        localStorage.removeItem("selectedServicesCart");
        localStorage.removeItem("selectedShortTerm");
        localStorage.removeItem("selectedLongTerm");
        localStorage.removeItem("activeCartType");
        window.dispatchEvent(new Event("cartUpdated"));

        showToast("Order placed successfully!", "success");
        setTimeout(() => {
          navigate("/thankyou", {
            state: {
              orderNo: response.result?.order_no || response.result?.order_id,
            },
          });
        }, 1500);
      } else {
        showToast(
          response?.msg || "Failed to place order. Please try again.",
          "error",
        );
      }
    } catch (err) {
      console.error("Error during checkout:", err);
      showToast(err.message || "An error occurred. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      {toast.show && (
        <div className={`custom-toast-notification custom-toast-${toast.type}`}>
          <CheckCircleIcon />
          <span>{toast.message}</span>
        </div>
      )}

      <div className="test_bredcum_sec">
        <div className="container-fluid">
          <div className="test_bredcum">
            <Link to="/">Home</Link>
            <span>&gt;</span>
            <Link to="/product-on-rent">Products on Rent</Link>
            <span>&gt;</span>
            <span className="name_p">Checkout</span>
          </div>
        </div>
      </div>

      <div className="booking_form_main">
        <div className="container-fluid">
          <div className="inner_booking_form">
            <form onSubmit={handlePayNow}>
              <div className="row">
                {/* LEFT FORM */}
                <div className="col-lg-7">
                  {/* Shipping Info Container */}
                  <div className="booking_box patient_info_form">
                    <h3>Patient / Contact Information</h3>
                    <div className="form_patient_info mt-3">
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="First Name *"
                            required
                            value={firstName}
                            readOnly
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Last Name"
                            value={lastName}
                            readOnly
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <input
                            type="tel"
                            className="form-control"
                            placeholder="Phone Number *"
                            required
                            value={phone}
                            readOnly
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Email Address"
                            value={email}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Delivery Address Radio Selector (Nursing Booking style) */}
                  <div className="booking_box sample_address">
                    <h3>Delivery Address</h3>
                    <div className="samele_add_radio_btn">
                      {addresses.length === 0 ? (
                        <p className="text-muted small p-2">
                          No saved addresses found. Please fill in custom
                          details below.
                        </p>
                      ) : (
                        addresses.map((addr) => (
                          <label className="address_box" key={addr.address_id}>
                            <input
                              type="radio"
                              name="shipping_address_radio"
                              checked={selectedAddressId === addr.address_id}
                              onChange={() => handleSelectLocalAddress(addr)}
                            />
                            <span className="radio_circle"></span>
                            <div className="address_content">
                              <h4 style={{ textTransform: "capitalize" }}>
                                {addr.address_title} Address
                              </h4>
                              <p>
                                <strong>{addr.address_name}</strong> (
                                {addr.address_phone})<br />
                                {addr.address_plot_no
                                  ? addr.address_plot_no + ", "
                                  : ""}
                                {addr.address_locility}, {addr.address_area},{" "}
                                {addr.address_city_name ||
                                  (addr.address_city === "1" ||
                                  addr.address_city === 1
                                    ? "Jaipur"
                                    : addr.address_city)}
                                ,{" "}
                                {addr.address_state_name ||
                                  (addr.address_state === "1" ||
                                  addr.address_state === 1
                                    ? "Rajasthan"
                                    : addr.address_state)}{" "}
                                - {addr.address_pincode}
                              </p>
                            </div>
                          </label>
                        ))
                      )}

                      <div className="add_more_btn">
                        <button
                          type="button"
                          onClick={() => setShowAddressModal(true)}
                        >
                          <AddOutlinedIcon style={{ fontSize: "18px" }} /> Add
                          New Address
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Payment Method & Notes
                  <div className="booking_box sample_address">
                    <h3>Payment & Notes</h3>
                    <div className="form_patient_info mt-3">
                      <div className="row">
                        <div className="col-md-12 mb-3">
                          <label className="form-label text-dark fw-bold mb-2">Select Payment Method</label>
                          <div className="d-flex gap-4">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="paymentMethod"
                                id="cod"
                                value="Cash on Delivery"
                                checked={paymentMethod === "Cash on Delivery"}
                                onChange={(e) => setPaymentMethod(e.target.value)}
                              />
                              <label className="form-check-label text-dark" htmlFor="cod">
                                Cash on Delivery
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="paymentMethod"
                                id="online"
                                value="Online"
                                checked={paymentMethod === "Online"}
                                onChange={(e) => setPaymentMethod(e.target.value)}
                              />
                              <label className="form-check-label text-dark" htmlFor="online">
                                Pay Online (Cards/UPI)
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <textarea
                            className="form-control"
                            placeholder="Additional notes or delivery instructions (optional)"
                            rows="2"
                            value={orderNotes}
                            onChange={(e) => setOrderNotes(e.target.value)}
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                  */}
                </div>

                {/* RIGHT SUMMARY */}
                <div className="col-lg-5">
                  <div className="for_sticky_section">
                    {/* Summary Box */}
                    <div className="summary_sec booking_box">
                      <h3 className="summary-heading">Summary</h3>
                      <div className="price_booking">
                        {cartItems.map((item, idx) => (
                          <div className="name_price_booking top-nam" key={idx}>
                            <div className="summary-p-nameouter">
                              <div className="summary-p-img">
                                <img
                                  src={item.me_image}
                                  alt={item.me_product_name}
                                  style={{
                                    maxWidth: "100%",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                              <div>
                                <h4 className="fw-bold mb-0 text-dark">
                                  {item.me_product_name}
                                </h4>
                                <span>
                                  Duration:{" "}
                                  {item.attribute?.attribute_value ||
                                    "Standard Plan"}{" "}
                                  | Qty: {item.cart_qty}
                                </span>
                              </div>
                            </div>

                            <h5>
                              ₹{parseFloat(item.cart_unit_price).toFixed(2)}
                            </h5>
                          </div>
                        ))}

                        <div className="name_price_booking pt-3 border-top">
                          <h4>Package Subtotal</h4>
                          <h5>
                            ₹{parseFloat(summary.product_total || 0).toFixed(2)}
                          </h5>
                        </div>

                        {/* <div className="name_price_booking">
                          <h4>Refundable Security Deposit</h4>
                          <h5>
                            ₹
                            {parseFloat(summary.security_total || 0).toFixed(2)}
                          </h5>
                        </div> */}

                        <div className="name_price_booking">
                          <h4>GST (5%)</h4>
                          <h5>
                            ₹{parseFloat(summary.gst_total || 0).toFixed(2)}
                          </h5>
                        </div>
                      </div>

                      <div className="total_price_booking mt-3 pt-2">
                        <h4>Total</h4>
                        <h5
                          className="text-success fw-bold"
                          style={{ fontSize: "20px" }}
                        >
                          ₹{parseFloat(summary.grand_total || 0).toFixed(2)}
                        </h5>
                      </div>
                    </div>
                    <div class="form-check term-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="checkChecked"
                        checked
                      />
                      <label class="form-check-label" for="checkChecked">
                        By Clicking you will be agree to our{" "}
                        <Link to="/terms-and-condition">
                          {" "}
                          Terms & Conditions
                        </Link>{" "}
                        and <Link to="/privacy-policy"> Privacy Policy</Link>
                      </label>
                    </div>
                    {/* Bottom Pay Bar */}
                    {/* <div className="total_payble booking_box">
                      <div className="text_payble">
                        <p>Total Payable</p>
                        <h5>
                          ₹{parseFloat(summary.grand_total || 0).toFixed(2)}/-
                        </h5>
                        <p>(Inclusive of all taxes)</p>
                      </div>
                      <div className="book_now_payble">
                        <button
                          type="submit"
                          disabled={loading}
                          style={{
                            background: "#D6EAE8",
                            color: "#1E293A",
                            padding: "12px 23px",
                            borderRadius: "8px",
                            fontSize: "19.43px",
                            fontWeight: "600",
                            border: "none",
                            boxShadow: "0px 5px 12px #00000026",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          {loading ? "Placing..." : "Book Now"}{" "}
                          <EastOutlinedIcon />
                        </button>
                      </div>
                    </div> */}

                    <button
                      type="submit"
                      disabled={loading}
                      className="checkout-btn"
                    >
                      {loading ? "Booking..." : "Book Now"}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <Footer />

      <AddAddressModal
        show={showAddressModal}
        onClose={() => setShowAddressModal(false)}
        onSuccess={handleAddAddressSuccess}
      />
    </>
  );
}
